import React, { useEffect, useState } from "react";
import { Layout, Menu, Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import logo from "../Assets/logo.svg"
import logoNew from "../Assets/ldclogo.png"
import icon1 from '../Assets/dashboard-line.png'
import icon2 from '../Assets/money-pound-box-line.png'
import icon3 from '../Assets/empathize-line.png'
import icon4 from '../Assets/health-book-line.png'
import icon5 from '../Assets/hearts-line.png'
import icon6 from '../Assets/hospital-line.png'
import icon7 from '../Assets/close-circle-line.png'
import icon8 from '../Assets/loop-right-fill.png'
import icon9 from '../Assets/wallet-2-line.png'
import icon10 from '../Assets/user-settings-line@2x.png'
import icon11 from '../Assets/mail-line.png'
import icon12 from '../Assets/chat-3-line.png'
import icon13 from '../Assets/alert-line.png'
import icon14 from '../Assets/apps-line.png'
import icon15 from '../Assets/user-3-line.png'
import './LayoutMobile.css'
const { Header, Sider, Content } = Layout;

const App = (props) => {
    // console.log('props ::::',props)
    let userTempData = localStorage.getItem('userData'), userData = {}
    if (userTempData) {
        userData = JSON.parse(userTempData)
    }
    const navigate = useNavigate();
    const [selectedKey, setSelectedKey] = useState(null);
    let showCategoryTemp = localStorage.getItem('showCategory')
    const [productCategories, setproductCategories] = useState(showCategoryTemp ? JSON.parse(showCategoryTemp) : null);
    useEffect(() => {
        const currentPath = window.location.pathname;
        const activeMenu = menus.find((menu) => menu.href === currentPath);
        if (activeMenu) {
            setSelectedKey(activeMenu.key);
        }
    }, [])

    useEffect(() => {
        if (props.productCategories) {
            // console.log('props.productCategories ::', props.productCategories)
            setproductCategories(props.productCategories)

        }
    }, [props?.productCategories?.category1])

    const menus = [
        { key: '1', label: "Dashboard", href: "/dashboard", icon: <img src={icon1} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '2', label: "GP Pricing Matrix", href: "/gp-pricing", icon: <img src={icon2} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '17', label: "GP Product Admin", href: "/gp-product-admin", icon: <img src={icon5} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        {
            key: '3', label: "Product Categories", href: "/product-categories", icon: <img src={icon4} />, style: { textAlign: 'left' }, className: "sidebarMenu"
        },
        {
            key: '4', label: productCategories && productCategories?.category1 && productCategories?.category1.name ? productCategories.category1.name : "GP appointments", href: "/gp-product-admin", style: { textAlign: 'center', padding: 0 }, className: "sidebarSubMenu1"
        },
        {
            key: '5', label: productCategories && productCategories?.category2 && productCategories?.category2.name ? productCategories.category2.name : "Health  screens ", href: "/product-category", style: { textAlign: 'center', padding: 0 }, className: "sidebarSubMenu2"
        },
        { key: '6', label: "Clinician Profile", href: "/clinician-profile", icon: <img src={icon3} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '7', label: "Clinic Settings", href: "/clinic-settings", icon: <img src={icon6} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '8', label: "Cancellation Rules", href: "/cancellation-rules", icon: <img src={icon7} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '9', label: "Rescheduling Rules", href: "/rescheduling-rules", icon: <img src={icon8} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '10', label: "Payment Settings", href: "/payment-settings", icon: <img src={icon9} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '11', label: "User Management", href: "/user-management", icon: <img src={icon15} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '12', label: "Generic Email Copy", href: "/generic-email-copy", icon: <img src={icon11} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '13', label: "Generic SMS Copy", href: "/generic-sms-copy", icon: <img src={icon12} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '14', label: "Alert", href: "/alert", icon: <img src={icon13} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '15', label: "Other", href: "/others", icon: <img src={icon14} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
        { key: '16', label: "Profile", href: "/profile", icon: <img src={icon15} />, style: { textAlign: 'left' }, className: "sidebarMenu" },
    ];

    const handleMenuClick = ({ item, key, keyPath, domEvent }) => {
        // console.log({ item, key, keyPath, domEvent }, '{ item, key, keyPath, domEvent }')
        // return
        setSelectedKey(key);  // Set selected key first
        if (keyPath && keyPath.length && keyPath.length == 2) {
            const menuItem = menus.find((item) => item.key === keyPath[1]);
            if (menuItem) {
                const childMenuItem = menuItem.children?.find((item) => item.key === key);
                if (childMenuItem) {
                    navigate(childMenuItem.href);
                }
            }
        } else {
            const menuItem = menus.find((item) => item.key === key);
            if (menuItem) {
                navigate(menuItem.href);
            }

        }

    };
    return (
        <Layout style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
            {/* Navbar */}
            <Header
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: "white",
                    padding: "0 20px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    // background: "#fff"
                }}
            >
                <div style={{ color: "black", margin: 0, fontSize: "20px", marginLeft: "auto", fontWeight: 'bold' }}>
                    Hi,<span style={{ fontSize: "20px", fontWeight: 'normal' }}> {userData?.name} </span>
                </div>
            </Header>
            {/* Sidebar */}
            <Layout >
                <Sider
                    width={250}
                    theme="dark"
                    style={{ borderRight: "2px solid #fff", background: "#fff", marginTop: "-5%", position: "relative" }}
                    className="dashboardSidebar"
                >
                    <div style={{
                        width: '250px',
                        height: '133px',
                        backgroundColor: '#008385',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}

                    >
                        <img
                            src={"https://pbldcbe.webdezign.uk/static/media/ldclogo.1f2a7d791d5f16307994.png"}
                            alt="Logo"
                            style={{
                                width: '100%',  // Makes it responsive 
                                maxWidth: '193px',
                                height: 'auto',
                                transition: "width 0.3s ease"
                            }}
                        />
                    </div>
                    <Menu
                        theme="light"
                        mode="inline"
                        color="white"
                        // defaultSelectedKeys={[selectedKey]}
                        selectedKeys={[selectedKey]}
                        onClick={handleMenuClick}
                        style={{ borderRight: "none", fontSize: "15px", color: "white" }}
                        items={menus}
                        className="sidebarNav"

                    >
                        {/* {menus.map((item, index) => (
                            <Menu.Item key={item.label} icon={item.icon} style={{ textAlign: 'left', marginTop: '47px' }}>
                                <Link style={{ color: "#000", textAlign: 'left' }} to={item.href} >{item.label}</Link>
                            </Menu.Item>
                        ))} */}
                    </Menu>

                </Sider>
                <Layout style={{ padding: "20px", background: "#eef1f5" }}>
                    <Content
                        style={{
                            background: "#f0fafa",
                            padding: 30,
                            borderRadius: 10,
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        {props.children}
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

export default App;